import { render, staticRenderFns } from "./NotificationComponent.vue?vue&type=template&id=83bae6ea"
import script from "./NotificationComponent.vue?vue&type=script&lang=ts"
export * from "./NotificationComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports